import React from 'react';
import Helmet from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function Seo({ title, titleTemplate, lang, meta, description, ogimage, slug }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            titleTemplate
            ogimage
            siteUrl
          }
        }
      }
    `
  );
  const siteTitleTemplate = titleTemplate || site.siteMetadata.titleTemplate;
  const ogpath = ogimage || site.siteMetadata.ogimage;
  const ogurl = slug
    ? `${site.siteMetadata.siteUrl}${slug}`
    : site.siteMetadata.siteUrl;
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={siteTitleTemplate}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:image',
          content: `${site.siteMetadata.siteUrl}${ogpath}`,
        },
        {
          name: 'og:description',
          content: description,
        },
        {
          name: 'og:url',
          content: ogurl,
        },
      ].concat(meta)}
    />
  );
}

Seo.defaultProps = {
  lang: 'en',
  titleTemplate: '',
  meta: [],
  ogimage: null,
};

export default Seo;
